import React from 'react'

import { TabChildItem, TabContainer } from './style'

const ToggleThreeOptions = ({
  handleClick,
  disabled = false,
  tabs,
  current,
  equalSpace = false,
  width,
  alignText,
  activeStyle,
  normalTextColor,
  normalFontWeight,
  tabMarginBottom,
  pointerEventsNone,
  defaultColor,
}) => {
  return (
    <TabContainer
      disabled={disabled}
      border={tabs?.length <= 0}
      width={width}
      equalSpace={equalSpace}
      activeStyle={activeStyle}
      customBorder={tabs?.length <= 0}
      tabMarginBottom={tabMarginBottom}
    >
      {tabs.map((tab, index) => {
        return (
          <TabChildItem
            active={tab.value === current}
            onClick={() => handleClick(tab)}
            disabled={disabled}
            key={index + 'tabItem'}
            equalSpace={equalSpace}
            alignText={alignText}
            activeStyle={activeStyle}
            normalTextColor={normalTextColor}
            normalFontWeight={normalFontWeight}
            showBorderBetween={
              activeStyle?.showBorderBetween &&
              index === activeStyle?.showBorderBetween
            }
            pointerEventsNone={pointerEventsNone}
          >
            {tab.label}
          </TabChildItem>
        )
      })}
    </TabContainer>
  )
}

export default ToggleThreeOptions
